/**
 * Re-exports of Orval-generated Rio message types.
 *
 * `ToolNameEnum` is the generated name for the Rio tool-name enum
 * (from api/enum/rio_enums.py → schema.yaml → codegen). Adding a new
 * apply_* tool: add to rio_enums.py, run codegen — ToolNameEnum updates
 * automatically, TypeScript flags missing cases in RioEditsList.tsx.
 */
export type { RioMessage, RioToolPayload, RioMessageList } from "@api/rest/types-and-hooks";
export { ToolNameEnum } from "@api/rest/types-and-hooks";

/** Turn "apply_open_prompt_pr" into "Open prompt PR". Used by both
 *  edits-list variants as a fallback when a tool name isn't
 *  explicitly cased. */
export function humanizeToolName(name: string): string {
  const stripped = name.replace(/^apply_/, "").replace(/_/g, " ");
  const sentenced = stripped.charAt(0).toUpperCase() + stripped.slice(1);
  return sentenced.replace(/\bpr\b/gi, "PR").replace(/\bapi django\b/gi, "api-django");
}
